var map = {
	"../evaluations/evaluations.module": [
		"./src/app/pages/evaluations/evaluations.module.ts"
	],
	"../modules/modules.module": [
		"./src/app/pages/modules/modules.module.ts",
		"modules-modules-module"
	],
	"./pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts",
		"pages-auth-auth-module"
	],
	"./pages/redirect/redirect.module": [
		"./src/app/pages/redirect/redirect.module.ts",
		"pages-redirect-redirect-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;